export const enum TabNames {
  Course = 'course',
  Overview = 'overview',
  MindMap = 'mindMap',
  VideoTranscribe = 'videoTranscribe',
  TestMindMap = 'TestMindMap',
}

export const enum TabLabels {
  MindMap = 'course.page.mindmap',
  Overview = 'course.page.overview',
  Course = 'course.page.coursecontent',
  TestMindMap = 'course.page.testmindmap',
  VideoTranscribe = 'course.page.videotranscription',
}

export const tabs: Array<{
  name: TabNames;
  label: TabLabels;
  permission?: boolean;
}> = [
  { name: TabNames.Overview, label: TabLabels.Overview },
  { name: TabNames.MindMap, label: TabLabels.MindMap },
  { name: TabNames.VideoTranscribe, label: TabLabels.VideoTranscribe },
  {
    // TODO(Kuriy): it's a temporary solution for the test purpose
    name: TabNames.TestMindMap,
    label: TabLabels.TestMindMap,
    permission: true,
  },
];
